import { render, staticRenderFns } from "./wxTipmask.vue?vue&type=template&id=59581d9d&scoped=true&"
import script from "./wxTipmask.vue?vue&type=script&lang=js&"
export * from "./wxTipmask.vue?vue&type=script&lang=js&"
import style0 from "./wxTipmask.vue?vue&type=style&index=0&id=59581d9d&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59581d9d",
  null
  
)

export default component.exports